<template>
  <div>
    <v-dialog v-model="dialogPhotos" max-width="800px" @keydown.esc="closeModal">
      <v-card>
        <v-card-title class="headline">
          <span>Imágenes de recepción</span>
        </v-card-title>
        <v-card-text>
          <div v-if="normalizedPhotos && normalizedPhotos.length > 0">
            <v-carousel
              height="400"
              cycle
              delimiter-icon="mdi-minus"
              hide-delimiter-background
            >
              <v-carousel-item
                v-for="(photo, index) in normalizedPhotos"
                :key="index"
              >
                <v-img
                  :src="photo.photo_url"
                  height="400px"
                  contain
                >
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-carousel-item>
            </v-carousel>
          </div>
          <div v-else class="text-center py-8">
            <v-icon size="64" color="grey lighten-2">mdi-image-off</v-icon>
            <p class="text-grey mt-4">No hay imágenes disponibles</p>
          </div>
        </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="closeModal()">Cerrar</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template><script>
export default {
  name: 'ModalViewImages',
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    photos: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    dialogPhotos: {
      get() {
        return this.dialog;
      },
      set(value) {
        if (!value) {
          this.closeModal();
        }
      }
    },
    normalizedPhotos() {
      if (!this.photos || this.photos.length === 0) {
        return [];
      }
      
      // Si es un array de strings (desde ASN)
      if (typeof this.photos[0] === 'string') {
        return this.photos.map(url => ({
          photo_url: url
        }));
      }
      
      // Si es un array de objetos (desde Recepcion)
      return this.photos;
    }
  },
  methods: {
    closeModal() {
      this.$emit('updateDialog', false);
    },
  },
};
</script>
